import * as styles from './AuditSessionsFilters.css';

interface SessionsFilterActionsProps {
  filtersActive: boolean;
  activeFilterCount: number;
  onClearAllFilters: () => void;
  isLoading?: boolean;
}

/**
 * Filter actions component with active filters indicator and clear all button
 */
export function SessionsFilterActions({ filtersActive, activeFilterCount, onClearAllFilters, isLoading = false }: SessionsFilterActionsProps) {
  return (
    <div className={styles.filterActions}>
      {filtersActive && (
        <div className={styles.activeFiltersIndicator}>
          {activeFilterCount} filter{activeFilterCount !== 1 ? 's' : ''} active
        </div>
      )}

      <button className={styles.clearFiltersButton} disabled={!filtersActive || isLoading} type="button" onClick={onClearAllFilters}>
        Clear All Filters
      </button>
    </div>
  );
}
